import React from "react";
import { Route, Routes } from "react-router";
import { Dashboard } from "@/components/Dashboard";
import { Register } from "@/components/Register";
import { ForgotPassword } from "@/components/ForgotPassword";
import { Profile } from "@/components/Profile";
import CreateAssessmentFlow from "@/components/CreateAssessmentFlow";
import { AssessmentView } from "@/components/AssessmentView";
import { TakeAssessment } from "@/components/TakeAssessment";
import Assessments from "@/components/Assessments";
import { ViewCandidateAssessment } from "@/components/ViewCandidateAssessment";
import { Teams } from "@/components/Teams";
import { ProtectedRoute } from "./ProtectedRoute";

export function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/teams"
        element={
          <ProtectedRoute>
            <Teams />
          </ProtectedRoute>
        }
      />
      <Route
        path="assessments/new"
        element={
          <ProtectedRoute>
            <CreateAssessmentFlow />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assessments/:uuid"
        element={
          <ProtectedRoute>
            <AssessmentView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assessment/take/:candidateId"
        element={<TakeAssessment />}
      />
      <Route
        path="/assessments"
        element={
          <ProtectedRoute>
            <Assessments />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assessment/candidates/:candidateId"
        element={
          <ProtectedRoute>
            <ViewCandidateAssessment />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
